import React from "react";

const Footer = () => {
  return (
    <footer>
      <div>
        <p>A simple experiment with ml5 machine learning library</p>
      </div>
    </footer>
  );
};

export default Footer;
